import type { Client } from "../client";
import type { NewTriggerResource, TriggerResource } from "../resources";
import BasicRepository from "./basicRepository";

class ProjectTriggerRepository extends BasicRepository<TriggerResource, NewTriggerResource> {
    constructor(client: Client) {
        super("ProjectTriggers", client);
    }
}

export default ProjectTriggerRepository;
